import * as React from 'react';

import Button from 'components/button';
import { translate } from 'components/translate-hoc';
import AnalyticsService from 'modules/analytics-provider/analytics-provider.service';
import { SUBMIT_ANOTHER_CODE_ANALYTICS } from './resubmit-code-button.constants';
import { IResubmitCodeButtonProps } from './resubmit-code-button.types';
export class ResubmitCodeButton extends React.Component<IResubmitCodeButtonProps> {
    public handleReSubmitClick = (): void => {
        const { additionalAnalyticsInfo = {}, onReSubmit } = this.props;
        AnalyticsService.sendFlowEvent({
            ...SUBMIT_ANOTHER_CODE_ANALYTICS,
            ...additionalAnalyticsInfo,
        });

        return onReSubmit();
    };

    public render() {
        const { dangerouslyTranslateWithHTML: translateKey } = this.props;
        const resubmitButtonText = translateKey('redeem_try-again__button-text');

        return (
            <Button onClick={this.handleReSubmitClick}>
                {resubmitButtonText}
            </Button>
        );
    }
}

export default translate()(ResubmitCodeButton);
